"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import { checkUserIdExist } from '../../api/Profile';

const errorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger"
}, msg);
class UserIdChangeForm extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "enableSubmit", (currentPasswordArg, newUserIdArg, confirmUserIdArg) => {
      let {
        currentPassword,
        userId: newUserId,
        confirmUserId
      } = this.state;
      const {
        handleValidation
      } = this.props;
      let currentLoginUserID = sessionStorage.getItem('currentLoginUserID');
      if (currentLoginUserID === null) {
        currentLoginUserID = '';
      }
      if (currentPasswordArg) {
        currentPassword = currentPasswordArg;
      }
      if (newUserIdArg) {
        newUserId = newUserIdArg;
      }
      if (confirmUserIdArg) {
        confirmUserId = confirmUserIdArg;
      }
      if (currentPassword && currentPassword.length > 0 && newUserId && newUserId.length > 0 && confirmUserId && confirmUserId.length > 0 && newUserId.toLowerCase() === confirmUserId.toLowerCase() && newUserId.length >= 8 && newUserId.length <= 60 && currentLoginUserID.toLowerCase() !== newUserId.toLowerCase()) {
        handleValidation(true);
      } else {
        handleValidation(false);
      }
    });
    _defineProperty(this, "handleUserIdChange", e => {
      const userId = e.target.value;
      e.persist();
      this.enableSubmit(null, userId, null);
      this.setState({
        userId
      }, () => {
        this.onUserIDChange();
      });
    });
    _defineProperty(this, "handleUserIdBlur", e => {
      const userId = e.target.value;
      e.persist();
      this.enableSubmit(null, userId, null);
      this.setState({
        userId
      }, () => {
        this.onUserIDBlur();
      });
    });
    _defineProperty(this, "handleConfirmUserIdChange", e => {
      const confirmUserId = e.target.value;
      e.persist();
      this.enableSubmit(null, null, confirmUserId);
      this.setState({
        confirmUserId
      }, () => {
        this.onConfirmUserIdChange();
      });
    });
    _defineProperty(this, "handleConfirmUserIdBlur", e => {
      const confirmUserId = e.target.value;
      this.enableSubmit(null, null, confirmUserId);
      this.setState({
        confirmUserId
      }, () => {
        this.onConfirmUserIdBlur();
      });
      e.persist();
    });
    _defineProperty(this, "handleCurrentPasswordChange", e => {
      const currentPassword = e.target.value;
      e.persist();
      this.enableSubmit(currentPassword, null, null);
      this.setState({
        currentPassword
      }, () => {
        this.onPasswordChange();
      });
    });
    this.state = {
      userId: '',
      confirmUserId: '',
      currentPassword: undefined,
      userIdError: null,
      confirmUserIdError: null,
      currentPasswordError: null,
      serviceError: null,
      userIdSuccess: false
    };
  }
  onValidations() {
    this.onUserIDChange();
    this.onUserIDBlur();
    this.onConfirmUserIdChange();
    this.onConfirmUserIdBlur();
    this.onPasswordChange();
  }
  onSubmit() {
    this.onValidations();
  }
  onUserIDChange() {
    const {
      userId
    } = this.state;
    const currentLoginUserID = sessionStorage.getItem('currentLoginUserID');
    if (userId.length === 0) {
      this.setState({
        userIdError: errorMessage('This field is required for submission')
      });
    } else if (userId.toUpperCase() === currentLoginUserID.toUpperCase()) {
      this.setState({
        userIdError: errorMessage('New User Id should not be same as current User Id')
      });
    } else {
      this.setState({
        userIdError: null
      });
    }
  }
  onUserIDBlur() {
    const {
      userId,
      confirmUserId
    } = this.state;
    const currentLoginUserID = sessionStorage.getItem('currentLoginUserID');
    if (userId.length === 0) {
      this.setState({
        userIdError: errorMessage('This field is required for submission')
      });
    } else if (userId.toUpperCase() === currentLoginUserID.toUpperCase()) {
      this.setState({
        userIdError: errorMessage('New User Id should not be same as current User Id')
      });
    } else if (confirmUserId.length > 0 && userId.toUpperCase() !== confirmUserId.toUpperCase()) {
      this.setState({
        confirmUserIdError: errorMessage('New user id does not match the confirm user id.')
      });
    } else if (userId.length < 8 || userId.length > 60) {
      this.setState({
        userIdError: errorMessage('Your User ID must be 8-60 characters.')
      });
    } else {
      this.setState({
        confirmUserIdError: null,
        userIdSuccess: false
      });

      // check userid exists or not
      // checkUserIdExist(userId).then((results) => {
      //   const errorMsg = results.data.message;
      //   if (results.data.successful === false) {
      //     this.setState({ userIdExists: true, userIdError: errorMessage(errorMsg) });
      //   } else {
      //     this.setState({
      //       userIdExists: false,
      //       userIdSuccess: true,
      //       userIdError: <p className="help is-success">{errorMsg}</p>,
      //     });
      //   }
      // });
    }
  }
  onConfirmUserIdChange() {
    const {
      confirmUserId
    } = this.state;
    if (confirmUserId.length === 0) {
      this.setState({
        confirmUserIdError: errorMessage('This field is required for submission')
      });
    } else {
      this.setState({
        confirmUserIdError: null
      });
    }
  }
  onConfirmUserIdBlur() {
    const {
      userId,
      confirmUserId
    } = this.state;
    if (confirmUserId.length === 0) {
      this.setState({
        confirmUserIdError: errorMessage('This field is required for submission')
      });
    } else if (userId.length > 0 && userId.toUpperCase() !== confirmUserId.toUpperCase()) {
      this.setState({
        confirmUserIdError: errorMessage('New user id does not match the confirm user id.')
      });
    } else {
      this.setState({
        confirmUserIdError: null
      });
    }
  }
  onPasswordChange() {
    const {
      currentPassword
    } = this.state;
    if (!currentPassword || currentPassword.length === 0) {
      this.setState({
        currentPasswordError: errorMessage('This field is required for submission')
      });
    } else {
      this.setState({
        currentPasswordError: null
      });
    }
  }
  render() {
    const {
      userId,
      confirmUserId,
      currentPassword,
      userIdError,
      confirmUserIdError,
      currentPasswordError,
      serviceError,
      userIdSuccess
    } = this.state;
    const {
      isLoading,
      isError
    } = this.props;
    if (isError) return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '244px',
        width: '584px'
      },
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, "We are unable to process your request. Please try again later. "));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '354px',
        width: '594px',
        position: 'absolute',
        zIndex: '2'
      },
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Spinner, null)) : '', /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.onSubmit,
      noValidate: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "userId-change-form"
    }, /*#__PURE__*/_react.default.createElement(_core.Row, null, /*#__PURE__*/_react.default.createElement(_core.Box, null, serviceError && /*#__PURE__*/_react.default.createElement(_core.Message, {
      color: "danger",
      type: "error",
      text: serviceError
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "userId",
      className: "label"
    }, "New User ID", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      // className={`input ${userIdError && userIdSuccess ?  'is-success' : 'is-danger'}`}
      className: `input ${userIdError && !userIdSuccess && 'is-danger'} ${userIdSuccess && 'is-success'}`,
      type: "userId",
      placeholder: "Enter new user id",
      id: "userId",
      name: "userId",
      size: "15",
      onChange: this.handleUserIdChange,
      onBlur: this.handleUserIdBlur,
      value: userId,
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "person")))), userIdError), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "confirmUserId",
      className: "label"
    }, "Confirm New User ID", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${confirmUserIdError && 'is-danger'}`,
      type: "userId",
      placeholder: "Confirm new user id",
      id: "confirmUserId",
      name: "confirmUserId",
      size: "15",
      onChange: this.handleConfirmUserIdChange,
      onBlur: this.handleConfirmUserIdBlur,
      value: confirmUserId,
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "person")))), confirmUserIdError), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "confirm-password",
      className: "label"
    }, "Current Password", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${currentPasswordError && 'is-danger'}`,
      type: "password",
      placeholder: "Enter current password",
      id: "confirm-password",
      name: "confirm-password",
      size: "15",
      onChange: this.handleCurrentPasswordChange,
      value: currentPassword || '',
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), currentPasswordError), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns"
    }, "\xA0"))))));
  }
}
var _default = exports.default = UserIdChangeForm;
UserIdChangeForm.propTypes = {
  isLoading: _propTypes.default.bool,
  isError: _propTypes.default.bool,
  handleValidation: _propTypes.default.func
};
//# sourceMappingURL=UserIdChangeForm.js.map